import { t, i18n } from '../core/i18n.js';
import { device } from '../core/device.js';
import { tvnav } from '../core/tvnav.js';
import { notify } from '../core/notify.js';
import { escapeHtml } from '../core/utils.js';
import { support } from '../core/support.js';

/* Pantalla «Soporte»: mis tickets, ticket nuevo (problema o idea) y conversación. Con la sesión de la cuenta (web) o,
   en la app independiente, con licencia activa; con topes que fija el servidor y que aquí se enseñan («Te quedan 2 hoy»). */

const fmt = (ms) => new Date(ms).toLocaleString(i18n.lang, { dateStyle: 'medium', timeStyle: 'short' });

function errText(e) {
    const key = ['license', 'session', 'network', 'unavailable', 'limit_open', 'limit_day', 'limit_month', 'limit_replies', 'empty', 'closed', 'rate_limited', 'not_found'].indexOf(e) !== -1 ? e : 'unavailable';
    return t('support.err.' + key);
}

export function openSupport({ onChange = () => {} } = {}) {
    const app = window.app;
    const id = 'sup-' + Date.now().toString(36);
    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup support-popup" id="${id}">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title" data-sup-title>${t('support.title')}</div>
                    <div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content"><div class="phone-body" data-sup-body><div class="spinner"></div></div></div>
            </div>
        </div>`,
        on: {
            open(p) {
                const el = p.el || document.getElementById(id);
                const body = el.querySelector('[data-sup-body]');
                const titleEl = el.querySelector('[data-sup-title]');
                const focus = () => { if (device.isTV || !device.hasTouch) setTimeout(() => tvnav.focusLayer(el), 60); };
                const set = (html, title) => { body.innerHTML = html; titleEl.textContent = title || t('support.title'); focus(); };

                const showList = async (note) => {
                    set('<div class="spinner"></div>');
                    if (!support.ready()) {
                        const gate = support.gate;
                        set(`<div class="phone-status is-error"><b>${t(gate ? 'support.needLicense' : 'support.err.session')}</b></div>${gate ? `<p class="pw-note">${t('support.needLicenseHelp')}</p>
                            <button type="button" class="btn btn-primary btn-lg btn-block" data-go-license data-nav-default><span class="mi">workspace_premium</span>${escapeHtml(gate.label())}</button>` : ''}`);
                        const go = body.querySelector('[data-go-license]');
                        if (go) go.addEventListener('click', () => { popup.close(); gate.run(onChange); });
                        return;
                    }
                    const r = await support.list();
                    onChange();
                    if (!r.ok) { set(`<div class="phone-status is-error">${escapeHtml(errText(r.error))}</div><button type="button" class="btn btn-block" data-retry data-nav-default><span class="mi">refresh</span>${t('common.retry')}</button>`); body.querySelector('[data-retry]').addEventListener('click', () => showList()); return; }
                    const u = r.usage.left;
                    const rows = r.tickets.map((x) => `<button type="button" class="btn btn-block support-ticket ${x.unread ? 'is-unread' : ''}" data-ticket="${x.id}"><span class="mi">${x.kind === 'idea' ? 'lightbulb' : 'bug_report'}</span><span class="support-ticket-body"><b>${escapeHtml(x.title)}</b><small>${escapeHtml(t('support.status.' + x.status))} · ${escapeHtml(fmt(x.updatedAt))}${x.unread ? ' · ' + escapeHtml(t('support.newReply')) : ''}</small></span></button>`).join('');
                    set(`${note ? `<div class="phone-status">${escapeHtml(note)}</div>` : ''}
                        <p class="pw-note">${t('support.intro')}</p>
                        <div class="phone-status">${escapeHtml(t('support.left', { day: u.day, month: u.month, open: u.open }))}</div>
                        <button type="button" class="btn btn-primary btn-lg btn-block" data-new data-nav-default ${u.day <= 0 || u.month <= 0 || u.open <= 0 ? 'disabled' : ''}><span class="mi">edit</span>${t('support.new')}</button>
                        ${u.open <= 0 ? `<p class="pw-note">${t('support.err.limit_open')}</p>` : u.day <= 0 ? `<p class="pw-note">${t('support.err.limit_day')}</p>` : u.month <= 0 ? `<p class="pw-note">${t('support.err.limit_month')}</p>` : ''}
                        <div class="support-list" data-nav-list>${rows || `<p class="pw-note">${t('support.none')}</p>`}</div>`);
                    body.querySelector('[data-new]').addEventListener('click', showNew);
                    body.querySelectorAll('[data-ticket]').forEach((b) => b.addEventListener('click', () => showTicket(b.getAttribute('data-ticket'))));
                };

                const showNew = () => {
                    set(`<div class="field"><label>${t('support.kind')}</label>
                            <div class="segmented support-kind" data-kind><button type="button" class="is-active" data-value="problem">${t('support.kind.problem')}</button><button type="button" data-value="idea">${t('support.kind.idea')}</button></div></div>
                        <div class="field"><label>${t('support.subject')}</label><input name="title" maxlength="100" autocomplete="off" data-nav-default/></div>
                        <div class="field"><label>${t('support.message')}</label><textarea name="body" rows="6" maxlength="2000" placeholder="${escapeHtml(t('support.messagePh'))}"></textarea></div>
                        <label class="support-diag"><input type="checkbox" name="diag" checked/> ${t('support.includeDiag')}</label>
                        <div class="field-error" data-err hidden></div>
                        <button type="button" class="btn btn-primary btn-lg btn-block" data-send><span class="mi">send</span>${t('support.send')}</button>
                        <button type="button" class="btn btn-block" data-back><span class="mi">arrow_back</span>${t('common.back')}</button>`, t('support.new'));
                    let kind = 'problem';
                    body.querySelector('[data-kind]').addEventListener('click', (e) => {
                        const b = e.target.closest('button[data-value]');
                        if (!b) return;
                        kind = b.getAttribute('data-value');
                        body.querySelectorAll('[data-kind] button').forEach((x) => x.classList.toggle('is-active', x === b));
                    });
                    body.querySelector('[data-back]').addEventListener('click', () => showList());
                    const send = body.querySelector('[data-send]');
                    send.addEventListener('click', async () => {
                        const err = body.querySelector('[data-err]');
                        const title = body.querySelector('[name="title"]').value.trim();
                        const text = body.querySelector('[name="body"]').value.trim();
                        if (!title || text.length < 10) { err.textContent = t('support.err.empty'); err.hidden = false; return; }
                        err.hidden = true;
                        send.disabled = true;
                        const r = await support.create({ kind, title, body: text, includeDiag: body.querySelector('[name="diag"]').checked });
                        if (!r.ok) { send.disabled = false; err.textContent = errText(r.error); err.hidden = false; return; }
                        notify.toast(t('support.sent'), { icon: 'check_circle', duration: 3500 });
                        showList(t('support.sentNote'));
                    });
                };

                const showTicket = async (tid) => {
                    set('<div class="spinner"></div>');
                    const r = await support.get(tid);
                    onChange();
                    if (!r.ok) { showList(errText(r.error)); return; }
                    const msgs = r.messages.map((m) => `<div class="support-msg ${m.author === 'staff' ? 'is-staff' : ''}"><small>${escapeHtml(t(m.author === 'staff' ? 'support.staff' : 'support.you'))} · ${escapeHtml(fmt(m.at))}</small><div>${escapeHtml(m.body).replace(/\n/g, '<br>')}</div></div>`).join('');
                    const closed = r.ticket.status === 'closed';
                    set(`<div class="phone-status"><b>${escapeHtml(r.ticket.title)}</b><br>${escapeHtml(t('support.kind.' + r.ticket.kind))} · ${escapeHtml(t('support.status.' + r.ticket.status))}</div>
                        <div class="support-thread">${msgs}</div>
                        ${closed ? `<p class="pw-note">${t('support.closedNote')}</p>` : r.repliesLeft <= 0 ? `<p class="pw-note">${t('support.err.limit_replies')}</p>` : `
                        <div class="field"><label>${t('support.reply')}</label><textarea name="body" rows="4" maxlength="2000"></textarea></div>
                        <div class="field-error" data-err hidden></div>
                        <button type="button" class="btn btn-primary btn-lg btn-block" data-send data-nav-default><span class="mi">send</span>${t('support.send')}</button>`}
                        <button type="button" class="btn btn-block" data-back><span class="mi">arrow_back</span>${t('common.back')}</button>`, r.ticket.title);
                    body.querySelector('[data-back]').addEventListener('click', () => showList());
                    const send = body.querySelector('[data-send]');
                    if (send) send.addEventListener('click', async () => {
                        const err = body.querySelector('[data-err]');
                        const text = body.querySelector('[name="body"]').value.trim();
                        if (!text) { err.textContent = t('support.err.empty'); err.hidden = false; return; }
                        send.disabled = true;
                        const rr = await support.reply(tid, text);
                        if (!rr.ok) { send.disabled = false; err.textContent = errText(rr.error); err.hidden = false; return; }
                        showTicket(tid);
                    });
                };

                showList();
            },
            closed() {
                try { popup.destroy(); } catch (e) { /* ya destruido */ }
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popup.open();
    return popup;
}
